import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/observeData";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1180px] items-center justify-between gap-6 px-4 md:px-6">
        <h1 className="flex items-center gap-2.5">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">99黑料</span>
              <span className="mt-1 text-[11px] font-medium tracking-[0.12em] text-foreground-500">
                舆情观察 · 消费避坑
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex cursor-pointer"
          >
            提交反馈
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 lg:hidden cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden" aria-label="移动导航">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex whitespace-nowrap justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 hover:bg-primary-600"
            >
              提交反馈
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}